/**
 * Asserts the existence of a value
 *
 * @param value - Value to assert
 */
function invariant(value: unknown): asserts value {
  if (!value) {
    throw new Error('Invariant violation');
  }
}

export default invariant;
